//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import Model from "@/models/mobile";
import CarNoInput from "@/components/carNo-input";
export default {
  components: {
    CarNoInput
  },
  data() {
    return {
      carType: "plate",
      formData: {
        carNo: "",
        unParkNo: "",
        freeDuration: "",
        busNo: "",
        imageUrl: "",
        inputTime: "",
        stopTime: "",
        receivableMoney: "",
        timestanp: ""
      },
      checkPass: false,
      checkMsg: "",
      rules: {}
    };
  },
  methods: {
    handleDone(value) {
      console.log(value);
    },
    async getDetail() {
      const { carNo, unParkNo } = this.formData;
      const { freeDuration } = this.$route.params;
      if (this.carType == "plate" && carNo.length < 7) {
        this.$message.error("请输入正确的车牌号码");
        return;
      }
      if (this.carType == "phone" && !/^1[3-9]\d{9}$/.test(carNo)) {
        this.$message.error("请输入正确的手机号码");
        return;
      }
      const { data } = await Model.getCodeDetail({
        carNo,
        unParkNo,
        freeDuration
      });
      if (data.success) {
        const { list } = data;
        for (let key in this.formData) {
          if (list[key] || list[key] == 0) {
            this.formData[key] = list[key];
          }
        }
      } else {
        this.$message.error(data.error);
      }
    },
    async checkCode() {
      const { unParkNo, busNo, timestanp } = this.formData;
      const { data } = await Model.checkCode({
        busNo,
        parkNo: unParkNo,
        updateTime: timestanp
      });
      if (data.success) {
        this.checkPass = true;
      } else {
        this.checkMsg = data.error;
      }
    },
    async onSubmit() {
      const {
        unParkNo,
        carNo,
        freeDuration,
        busNo,
        receivableMoney
      } = this.formData;
      if (this.carType == "plate" && carNo.length < 7) {
        this.$message.error("请输入正确的车牌号码");
        return;
      }
      if (this.carType == "phone" && !/^1[3-9]\d{9}$/.test(carNo)) {
        this.$message.error("请输入正确的手机号码");
        return;
      }
      if (receivableMoney === "") {
        this.$message.error("请输入车牌，并点击查询后，再提交领取停车券");
        return;
      }

      const { data } = await Model.submitCode({
        busNo,
        carNo,
        unParkNo,
        freeDuration
      });
      if (data.success) {
        this.$router.push("/mobile/resultPay");
      }
      data.success
        ? this.$message.success(data.msg)
        : this.$message.error(data.error);
    }
  },
  created() {
    const { parkNo, busNo, freeDuration, timestanp } = this.$route.params;
    this.formData.unParkNo = parkNo;
    this.formData.busNo = busNo;
    this.formData.timestanp = timestanp;
    this.formData.freeDuration = freeDuration;
    this.checkCode();
  }
};



// WEBPACK FOOTER //
// ./src/pages/mobile/ticket.vue